import React from 'react';

import styles from './MobileSubtitle.module.css';

type Props = {
  children: string,
}

const MobileSubtitle = ({ children }: Props) => (
  <div className={styles.subtitle}>{children}</div>
);

export default MobileSubtitle;
